<template>
  <div class="bill">
    <!-- 多频道列表 -->
    <div v-if="form.channel_data.channel_status == 1" class="channleList">
      <div v-for="(item, index) in form.channel_data.channel_list" :key="index" @click="goVideo(item)"
        class="channleListItem">
        <div class="channleListItem_cover channleListItem_coverMY">
          <div v-if="item.status != 1">
            <img v-if="item.status == 2" width="10px" src="@/assets/base_img/icon_again@2x.png" alt="">
            <img v-if="item.status == 0" width="10px" src="@/assets/base_img/icon_not@2x.png" alt="">
            <span v-if="item.status == 2 && form.is_multilingual == 2">已结束</span>
            <span v-if="item.status == 2 && form.is_multilingual == 1">Ended</span>
            <span v-if="item.status == 0 && form.is_multilingual == 2">未开始</span>
            <span v-if="item.status == 0 && form.is_multilingual == 1">Not started</span>
          </div>
          <div v-if="item.live_id == $route.query.id" class="channleListItem_coverMY_icon"><img
              src="@/assets/base_img/矩形channl.png" alt=""></div>
          <div style="flex:1"></div>
          <div class="text"><img width="10px" v-if="item.live_id == $route.query.id"
              src="@/assets/base_img/icon_live@2x.png" alt="">{{ item.channel_title || item.title }}
          </div>
        </div>
        <img class="channleListItem_cover_img" :src="item.cover_path" alt="">
      </div>

    </div>
    <!-- tab按钮 -->
    <div v-show='form.tab_data.is_enabled_tab == 1' class="btnBox pointer">
      <div @click="changeListNum(index, item.type)" v-for="(item, index) in form.tab_data.tab_list" :key="index">
        {{ item.title }}
        <span v-show="index == listNum" class="line"></span>
      </div>
    </div>

    <!-- tab详情，当配置图文tab时，第一个图文显示直播信息，其他隐藏 -->
    <div v-show='form.tab_data.is_enabled_tab == 1 && listNum == index' v-for="(item, index) in form.tab_data.tab_list"
      :key="index" class="showBox">
      <div v-show='item.type == "1"' class="p12 synopsis video_message">
        <div v-show="index == 0" class="video_name">
          {{ form.title }}
        </div>

        <div v-show="index == 0" class="textBox">
          <div v-if="form.begin_time" class="message">
            <img width="12px" src="@/assets/auto_img/时间@2x.png" alt="">
            Time：<span>{{ form.begin_time | time('YYYY.MM.DD') }}
              {{ form.begin_time | time('HH:mm') }}-{{ form.end_time | time('HH:mm') }}</span>
          </div>
          <div v-if="form.speaker" class="message">
            <img width="12px" src="@/assets/auto_img/术者@2x.png" alt="">
            Speaker：<span>{{ form.speaker }}</span>
          </div>
          <div v-if="form.address" class="message">
            <img width="12px" src="@/assets/auto_img/地点@2x.png" alt="">
            Location：<span>{{ form.address }}</span>
          </div>
          <div v-if="form.view" class="message">
            <img width="12px" src="@/assets/auto_img/观看@2x.png" alt="">
            Views：<span>{{ form.view }}</span>
          </div>
          <div v-if='form.is_sign_in == 1' class="is_sign_in">
            <img @click="showLogin" v-if="!form.sign_in_pic_path" width="100%" src="@/assets/签到@2x.png" alt="">
            <img @click="showLogin" v-if="form.sign_in_pic_path" width="100%" :src="form.sign_in_pic_path" alt="">
          </div>
          <div v-if='form.type == 2 && form.tag_log_path' class="is_sign_in">
            <img v-if="form.tag_log_path" style="width:unset;" height="100%" width="unset" :src="form.tag_log_path"
              alt="">

          </div>
        </div>
        <viewer :images='[item.content]'>
          <div v-html="item.content" class="haibao"></div>
        </viewer>

      </div>
      <div v-show='item.type == 2' @click='goOutUrl(item)' class="p12 richText"></div>
      <!-- 聊天框，聊天功能暂时未开发 -->
      <div v-show='item.type == 3' class="p12 out_url">聊天框</div>
    </div>

    <!-- 没有tab时直接显示直播信息 -->
    <div v-show='form.tab_data.is_enabled_tab == 2' class="showBox p12 synopsis video_message">
      <div class="video_name">
        {{ form.title }}
      </div>
      <div class="textBox">
        <div v-if="form.begin_time" class="message">
          <img width="12px" src="@/assets/auto_img/时间@2x.png" alt="">
          Time：<span>{{ form.begin_time | time('YYYY.MM.DD') }}
            {{ form.begin_time | time('HH:mm') }}-{{ form.end_time | time('HH:mm') }}</span>
        </div>
        <div v-if="form.speaker" class="message">
          <img width="12px" src="@/assets/auto_img/术者@2x.png" alt="">
          Speaker：<span>{{ form.speaker }}</span>
        </div>
        <div v-if="form.address" class="message">
          <img width="12px" src="@/assets/auto_img/地点@2x.png" alt="">
          Location：<span>{{ form.address }}</span>
        </div>
        <div v-if="form.view" class="message">
          <img width="12px" src="@/assets/auto_img/观看@2x.png" alt="">
          Views：<span>{{ form.view }}</span>
        </div>
        <div v-if='form.is_sign_in == 1' class="is_sign_in">
          <img @click="showLogin" v-if="!form.sign_in_pic_path" width="100%" src="@/assets/签到@2x.png" alt="">
          <img @click="showLogin" v-if="form.sign_in_pic_path" width="100%" :src="form.sign_in_pic_path" alt="">
        </div>
        <div v-if='form.type == 2 && form.tag_log_path' class="is_sign_in">
          <img v-if="form.tag_log_path" style="width:unset;" height="100%" width="unset" :src="form.tag_log_path"
            alt="">

        </div>
      </div>
      <viewer :images='[form.content]'>
        <div v-html="form.content" class="haibao"></div>
      </viewer>
    </div>

    <login :videoForm='form' :inputForm='send' @loginOK='loginOK' ref='loginBox'></login>
  </div>
</template>

<script>
import $ from 'jquery'
import { geiVideoForm, createForm, geiVideodetail } from '@/api/meetApi.js';
import comment from './comment.vue'; //评论互动
import login from './login.vue';//签到
export default {
  components: { comment, login },
  props: ['form'],
  data() {
    return {
      setINV: null,
      listNum: 0,
      login: '',
      send: {}
    };
  },
  created() {
    if (this.form.is_sign_in == 1) {
      this.geiVideoForm()
    }
    // let baseInfo = JSON.parse(localStorage.getItem('baseInfo'))
    // if (baseInfo && baseInfo.video_id) {
    //   this.login = baseInfo.video_id
    // }
    // this.$store.state.formwork.formwork = JSON.parse(JSON.stringify(this.$store.state.formwork.formBox.data.menuArr))


  },
  mounted() {

  },
  beforeDestroy() {
    if (this.ws) {
      this.ws.close();
    }
    if (this.setINV) {
      clearInterval(this.setINV)
    }
    if (this.getStatusTime) {
      clearInterval(this.getStatusTime)
    }
  },
  methods: {
    goVideo(item) {
      this.$emit('goVideo', item.live_id)
    },
    showLogin() {
      if (this.form.sign_in_before_live == 0) {
        if (this.form.status != 1) {
          return this.$message.error('Please sign in during the live broadcast!')
        }
      }
      if (this.login == this.$route.query.id) {
        return this.$message.error('You have already checked in, please do not check in again!');
      }
      console.log(this.send)
      this.$refs.loginBox.show()
    },
    ZDshowLogin() {
      if (this.form.status == 1 || this.form.sign_in_before_live == 1) {
        if (this.login == this.$route.query.id) {
          return
        } else {      
          if (this.form.is_first_display_sign_in == 1) {
            this.$refs.loginBox.show()
          }
        }
      }
    },
    // 获取签到数据
    // 获取表单数据。将素组赋值给vuex用于表单
    async geiVideoForm() {
      // 判断本地是否有上一次签到信息，有本场的禁用签到按钮
      let historyData = JSON.parse(localStorage.getItem('loginInfo_' + this.form.id))
      if (historyData && historyData.live_id == this.form.id) {
        this.login = historyData.live_id
        if (this.form.status == 1) {
          this.initWS(historyData.login_id)
          return
        }
      }

      let data = await geiVideoForm({ meeting_id: this.form.meeting_id })
      let his_base = JSON.parse(localStorage.getItem('login_base'))
      this.send = data.payload
      if (his_base && his_base.meeting_id == data.payload.meeting_id) {
        this.send.options.data.menuArr = this.mergeDeep(data.payload.options.data.menuArr, his_base.options.data.menuArr)
        this.ZDshowLogin()
        return
      }
      this.send = data.payload
      this.ZDshowLogin()
      if (!this.send || !this.send.name) {
        this.send = {
          options: {
            type: "formBox",
            form_type: "1",
            data: {
              menuArr: [{
                "type": "inputWork",
                "name": "Inpute",
                "label": "input框",
                "icon": "account-book",
                "options": {
                  "col": 24,
                  "typeof": 'input',
                  "label": "姓名",
                  "labelWidth": 80,
                  "value": "",
                  "type": "text",
                  "clearable": false,
                  "disabled": false,
                  "prefixIcon": null,
                  "suffixIcon": null,
                  "placeholder": "请输入姓名",
                  "requireMsg": "",
                  "require": false,
                  "reg": "",
                  "regMsg": ""
                }
              }, {
                "type": "inputWork",
                "name": "Inpute",
                "label": "input框",
                "icon": "account-book",
                "options": {
                  "col": 24,
                  "typeof": 'input',
                  "label": "医院",
                  "labelWidth": 80,
                  "value": "",
                  "type": "text",
                  "clearable": false,
                  "disabled": false,
                  "prefixIcon": null,
                  "suffixIcon": null,
                  "placeholder": "请输入医院",
                  "requireMsg": "",
                  "require": false,
                  "reg": "",
                  "regMsg": ""
                }
              }, {
                "type": "inputWork",
                "name": "Inpute",
                "label": "input框",
                "icon": "account-book",
                "options": {
                  "col": 24,
                  "typeof": 'input',
                  "label": "科室",
                  "labelWidth": 80,
                  "value": "",
                  "type": "text",
                  "clearable": false,
                  "disabled": false,
                  "prefixIcon": null,
                  "suffixIcon": null,
                  "placeholder": "请输入科室",
                  "requireMsg": "",
                  "require": false,
                  "reg": "",
                  "regMsg": ""
                }
              }, {
                "type": "selectWork",
                "name": "Selecte",
                "label": "Select框",
                "icon": "deployment-unit",
                "options": {
                  "col": 24,
                  "typeof": 'select',
                  "label": "职称",
                  "labelWidth": 80,
                  "value": undefined,
                  "multiple": false,
                  "clearable": false,
                  "filterable": false,
                  "disabled": false,
                  "placeholder": "请选择职称",
                  "optionsType": true,
                  "optionsArray": ["主任医师", "副主任医师", "主治医师", "其他"],
                  "optionsZd": "",
                  "requireMsg": "",
                  "require": false
                }
              }, {
                "type": "inputWork",
                "name": "Inpute",
                "label": "input框",
                "icon": "account-book",
                "options": {
                  "col": 24,
                  "typeof": 'input',
                  "label": "联系方式",
                  "labelWidth": 80,
                  "value": "",
                  "type": "text",
                  "clearable": false,
                  "disabled": false,
                  "prefixIcon": null,
                  "suffixIcon": null,
                  "placeholder": "请输入联系方式",
                  "requireMsg": "",
                  "require": false,
                  "reg": "",
                  "regMsg": ""
                }
              }],
              pageCss: {
                page_css_margin: "0px 0px 0px 0px",
                page_css_padding: "24px 24px 24px 24px",
                page_css_interval: 16,
                page_css_radius: 0,
                page_css_bgc: "#ffffff",
                textBgc: "rgba(255,255,255,1)",

                myCss: '',
              }
            }
          }
        }
      }
    },
    mergeDeep(obj1, obj2) {
      // 如果 obj1 或 obj2 不是对象，直接返回 obj2 覆盖 obj1
      if (typeof obj1 !== 'object' || obj1 === null) return obj2;
      if (typeof obj2 !== 'object' || obj2 === null) return obj1;

      let base1 = JSON.parse(JSON.stringify(obj1));
      let base2 = JSON.parse(JSON.stringify(obj2));

      base1.forEach((item, index) => {
        if (base2 && base2[index] && item.id == base2[index].id) {
          for (const key in item) {
            item[key] = base2[index][key];
          }
        } else {

        }
      })

      return base1;
    },
    // 签到提交
    async loginOK(msg) {
      console.log(msg, '9423')
      let sendData = JSON.parse(JSON.stringify(msg));
      sendData.live_id = this.form.id
      let data = await createForm(sendData)
      sendData.login_id = data.payload.id
      this.login = this.form.id
      this.$refs.loginBox.show()
      this.$message.success('签到成功！');
      this.initWS(sendData.login_id)
      // 存一份表单id判断是否是第一次签到
      localStorage.setItem('loginInfo_' + this.form.id, JSON.stringify({ live_id: this.form.id, login_id: data.payload.id }))
      // 存一份表单数据，用于切换直播回显
      localStorage.setItem('login_base', JSON.stringify(sendData))
    },
    changeListNum(index, type) {

      if (type == 'out_url') {
        // window.open(this.form.menuList[index].url,'_self ')
        window.location.href = this.form.menuList[index].url
        return
      }

      if (type == 'chatRoom') {
        $('html,body').animate({
          scrollTop: 9999999
        }, 500);
      } else {
        $('html,body').animate({
          scrollTop: 0
        }, 200);
      }

      this.listNum = index
    },
    initWS(id) {
      if (!id) {
        return
      }
      if (this.ws) {
        this.ws.close();
      }
      if (this.setINV) {
        clearInterval(this.setINV)
      }
      let _this = this
      // 实例化socket，这里的实例化直接赋值给this.ws是为了后面可以在其它的函数中也能调用websocket方法，例如：this.ws.close(); 完成通信后关闭WebSocket连接
      _this.ws = new WebSocket("wss://www.cndmcloud.com:9988")

      //监听是否连接成功
      _this.ws.onopen = () => {
        _this.getStatus()
        console.log('ws连接状态：' + _this.ws.readyState);
        //连接成功则发送一个数据
        _this.ws.send(JSON.stringify({
          cmd: 'socket_connect',
          id: id
        }));
      }

      //接听服务器发回的信息并处理展示
      _this.ws.onmessage = (data) => {
        // console.log('接收到来自服务器的消息：');
        // console.log(data)
        _this.setINV = setTimeout(() => {
          _this.ws.send(JSON.stringify({ cmd: "client_play_time", id: id }));
        }, 1000)
      }

      //监听连接关闭事件
      _this.ws.onclose = () => {
        //监听整个过程中websocket的状态
        console.log('ws连接状态：' + _this.ws.readyState);
        clearInterval(_this.setINV)
      }

      //监听并处理error事件
      _this.ws.onerror = function (error) {
        clearInterval(_this.setINV)
        console.log(error);
      }
    },
    async getStatus() {
      if (this.getStatusTime) {
        clearInterval(this.getStatusTime)
      }
      // 因为没有持续获取直播状态，所以需要定时获取。
      // 当websocket开启时，每隔10min获取一次直播状态
      let _this = this
      if (this.ws) {
        _this.getStatusTime = setInterval(async () => {
          let data = await geiVideodetail({ id: _this.$route.query.id, meeting_id: _this.$route.query.meeting_id })
          if (data.payload && data.payload.data && data.payload.data.status == 1) {
            return
          } else {
            if (_this.ws) {
              _this.ws.close();
            }
            if (_this.setINV) {
              clearInterval(_this.setINV)
            }
            if (_this.getStatusTime) {
              clearInterval(_this.getStatusTime)
            }
          }
        }, 1000 * 60 * 10)
      }
    }
  },
};
</script>

<style lang="less" scoped>
.showBox {
  font-size: 14px;
}

.channleList {
  overflow: auto;
  height: 80px;
  white-space: nowrap;
  background: #f8f8f8;
  padding: 8px;

  .channleListItem {
    width: 112px;
    display: inline-block;
    height: 100%;
    margin-right: 8px;
    border-radius: 4px;
    position: relative;

    .channleListItem_cover {
      border-radius: 4px;
      display: flex;
      font-weight: 400;
      font-size: 11px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      flex-direction: column;
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      padding: 3px;

      img {
        position: relative;
        top: -1px;
        margin-right: 4px;
      }

      .text {
        img {
          width: 10px;
          height: 10px;
        }
      }
    }

    .channleListItem_coverMY_icon {
      position: absolute;
      width: 12px;
      top: -11px;
      left: 0;
      right: 0;
      margin: auto;

      img {
        width: 12px;
      }
    }

    .channleListItem_coverMY {
      background: linear-gradient(180deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.7) 100%);
    }

    .channleListItem_cover_img {
      border-radius: 4px;
      width: 100%;
      height: 100%;
    }
  }

  .channleListItem:last-child {
    margin-right: 0;
  }
}

::-webkit-scrollbar {
  display: none;
  width: 10px;
  height: 10px;
}

* ::-webkit-scrollbar {
  display: none;
  width: 10px;
  height: 10px;
}

.bill {
  margin-bottom: 20px;
}

.line {
  position: absolute;
  width: 2em;
  left: 0;
  right: 0;
  margin: auto;
  height: 2px;
  background-color: #108ee9;
  bottom: 0;
  border-radius: 2px;
}

.btnBox {
  display: flex;
  line-height: 36px;
  border-bottom: 1px solid #ccc;

  div {
    flex: 1;
    text-align: center;
    position: relative;
  }

  .three {
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.choice {
  color: #1890ff;
}

.loadImg {
  padding: 12px;

  img {
    border-radius: 4px;
    overflow: hidden;
  }
}

.videoMessage {
  padding: 12px 12px 12px 12px;
  position: relative;

  .title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #323334;
    line-height: 26px;
    margin-bottom: 8px;
    position: relative;
  }

  .poa_box {
    position: absolute;
    right: 0px;
    bottom: 0;
    top: 0;
    margin: auto;
    // transform: translateY(-50%);
  }

  .message {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    margin-bottom: 4px;
    color: #8d8d8d;
    line-height: normal !important;
    text-align: left;
    font-style: normal;
    display: flex;
    align-items: center;

    img {
      margin-right: 4px;
    }

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #555555;
      line-height: 18px;
      text-align: left;
      font-style: normal;
    }
  }

  i {
    vertical-align: initial;
  }

  .min_title {
    position: relative;
  }
}

.haibao {
  padding: 0 0;
  margin-bottom: 12px;
}

.chatRoom,
.richText,
.url {
  padding: 12px;
}

:deep(.bigImg img) {
  width: 100% !important;
  height: unset;
}

.pt40 {
  padding-top: 40px;
}

.model {
  padding-bottom: 12px;
}

.is_sign_in {
  position: absolute;
  right: 0;
  height: 100%;
  min-height: 25px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  top: 0;

  img {
    width: 72px;
  }
}

.loginClass {
  opacity: 0.7;
}

.video_message {
  font-family: PingFangSC-Medium, PingFang SC;
  // font-size: 0px;
  // border-bottom: solid 1px #eaebef;

  .img_span {
    width: 16px;
    height: 16px;
    display: flex;
    margin-right: 4px;
    flex-direction: column;
    justify-content: center;
  }

  .video_name {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #232323;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    margin-bottom: 10px;
    position: relative;
  }

  .textBox {
    position: relative;
    margin-bottom: 12px;
  }

  .is_sign_in {
    position: absolute;
    right: 0;
    height: 100%;
    min-height: 25px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    top: 0;

    img {
      width: 72px;
    }
  }

  .video_css {
    font-size: 13px;
    display: flex;
    line-height: 16px;
    font-weight: 400;
    margin-bottom: 3px;
    color: #868686;
  }

  .haibao {
    // margin-top: 12px;
    width: 100%;

    img {
      width: unset !important;
      height: unset !important;
      width: 100%;
      width: 100%;
    }
  }
}

:deep(.richText img) {
  width: unset !important;
  height: unset !important;
  width: 100% !important;
}

:deep(.haibao img) {
  width: unset !important;
  height: unset !important;
  width: 100% !important;
}

.video_haibao {
  padding: 12px;
  padding-top: 0;

  img {
    width: 100%;
  }
}

.no_imgPoster {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.imgPoster {
  width: 100%;
  height: 100%;
}

.message,
.no_message {
  width: 100%;
}

.no_message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0.3;
  padding-top: 30px;

  img {
    width: 160px;
  }
}

.addMenu {
  width: 320px;
  background-color: #fff;

  .iconfont {
    font-size: 24px;
  }
}

.addMenu_top,
.addMenu_bot {
  div {
    display: flex;
    flex-wrap: wrap;

    // flex-direction: column;
    span {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-width: 70px;
      min-height: 70px;
      padding: 5px;
      background-color: #f7f9fc;
      margin-right: 10px;
      margin-bottom: 10px;
    }

    span:last-child {
      margin-right: 0;
    }

    span:hover {
      background-color: #ccc;
    }
  }
}

.message {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  margin-bottom: 4px;
  color: #8d8d8d;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  display: flex;
  align-items: center;

  // justify-content: center;
  img {
    margin-right: 4px;
  }

  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #555555;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    flex: 1;
  }
}

i {
  vertical-align: initial;
}

.img_login {
  width: 90px;
}

.video_poster {
  width: 100%;
  height: 198px;
  background-color: #333;
}

.video_title {
  height: 40px;
  background-color: white;
  border-bottom: solid 1px #eaebef;
  display: flex;

  div {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    span {
      position: absolute;
      width: 2em;
      height: 2px;
      background-color: #108ee9;
      bottom: 0;
      border-radius: 2px;
    }
  }
}

.p12 {
  padding: 12px;
}
</style>
